import React from 'react'
import { useTranslation } from 'react-i18next';
import EcardCard from './EcardCard';

const EcardTab = () => {
  const { t } = useTranslation();
  return (
    <div className="tab-content__container">
        <h5>{t('twoja_ekarta')}</h5>
        <EcardCard />
    </div>
  )
}

export default EcardTab